export default "__VITE_ASSET__B5Ug$yFr__"